"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var react_dom_1 = __importDefault(require("react-dom"));
var supportsReactCreateRoot_1 = __importDefault(require("./supportsReactCreateRoot"));
function reactRender(domNode, reactElement) {
    if (supportsReactCreateRoot_1.default) {
        // @ts-expect-error potentially present if React 18 or greater
        var root = react_dom_1.default.createRoot(domNode);
        root.render(reactElement);
        return root;
    }
    // eslint-disable-next-line react/no-render-return-value
    return react_dom_1.default.render(reactElement, domNode);
}
exports.default = reactRender;
